import { Component } from '@angular/core';
import { Globals } from '../../../../../globals';
import { NavController } from 'ionic-angular';
import moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { ReservationLoaderPage } from '../../../../reservation/reservation-loader/reservation-loader';
import { ReservationsServices } from '../../../../reservation/services';

@Component({
    selector: 'page-home-reservations',
    templateUrl: 'home-reservations.html'
})


export class HomeReservationsPage {

    get_reservations: boolean = false;
    today_reservations: any = 0;
    number_pending_reservations: any = 0;
    pending_reservations: any;

    constructor(public globals: Globals,
        public navCtrl: NavController,
        public http: HttpClient,
        public reservationsServices: ReservationsServices) {
    }

    ngOnInit() {
        if (this.globals.restaurant.plg_reservas_finisher == true || this.globals.restaurant.plg_reservas_finisher == undefined) {
            this.todayReservations();
            this.pendingReservations();
        }
    }

    goToReservations() {
        this.globals.side_menu_active = 'reservation';
        this.navCtrl.setRoot(ReservationLoaderPage);
        this.globals.side_menu_active_analytics = false;
        this.globals.open_side_menu = false;
    }

    openPending() {
        this.globals.side_menu_active = 'reservation';
        this.navCtrl.setRoot(ReservationLoaderPage, {
            view: 'pending'
        });
    }

    openLanding() {
        if (this.globals.so_mobile) {
            window.location.assign('https://ads.mycheftool.com/reservas');
        } else {
            window.open('https://ads.mycheftool.com/reservas', '_blank');
        }
    }

    async todayReservations() {
        let date = moment().format("YYYY-MM-DD");
        await this.http.post(this.globals.analytics_path + 'total-reservations/' + this.globals.restaurant_uid + '/' + date, {}).subscribe(async data => {
            this.today_reservations = data;
            this.get_reservations = true;
        },
            err => {
            }
        );
    }

    async pendingReservations() {
        this.pending_reservations = await this.reservationsServices.getReservationsByState(this.globals.restaurant_uid, 'pending');
        if (this.pending_reservations) {
            this.number_pending_reservations = this.pending_reservations.number_reservations;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-cards/home-reservations/home-reservations.ts